import { useState, useEffect } from 'react';

function useStickyState(defaultValue, key, ttl = null) {
    const [value, setValue] = useState(() => {
        const stickyValue = window.localStorage.getItem(key);
        if (stickyValue !== null) {
            const { value, expiry } = JSON.parse(stickyValue);
            if (ttl && expiry && new Date().getTime() > expiry) {
                window.localStorage.removeItem(key);
                return defaultValue;
            }
            return value;
        }
        return defaultValue;
    });

    useEffect(() => {
        const expiry = ttl ? new Date().getTime() + ttl : null;
        window.localStorage.setItem(key, JSON.stringify({ value, expiry }));
    }, [key, value, ttl]);

    return [value, setValue];
}

export default useStickyState;